import { render } from "./insure-special-agreement.vue?vue&type=template&id=2da090ea&scoped=true"
import script from "./insure-special-agreement.vue?vue&type=script&lang=js"
export * from "./insure-special-agreement.vue?vue&type=script&lang=js"

import "./insure-special-agreement.vue?vue&type=style&index=0&id=2da090ea&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da090ea"]])

export default __exports__